import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { BackgroundMusicProvider } from "@/context/BackgroundMusicContext";
import { trackVisit } from "@/lib/tracking";

import Header from "@/components/Header";
import AudioPlayer from "@/components/AudioPlayer";
import { BackgroundMusicFloatingPill } from "@/components/BackgroundMusicToggle";

import Landing from "@/pages/Landing";
import Episodes from "@/pages/Episodes";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";
import EpisodeDetail from "@/pages/EpisodeDetail";
import Unsubscribe from "@/pages/Unsubscribe";
import Profile from "@/pages/Profile";

function VisitTracker() {
  const loc = useLocation();
  useEffect(() => { trackVisit(loc.pathname); }, [loc.pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-ink min-h-screen text-white">
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <BackgroundMusicProvider>
              <VisitTracker />
              <Header />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/episodes" element={<Episodes />} />
                <Route path="/episodes/:number" element={<EpisodeDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/success" element={<Success />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
              </Routes>
              <AudioPlayer />
              <BackgroundMusicFloatingPill />
              <Toaster
                position="top-center"
                theme="dark"
                toastOptions={{
                  style: { background: "#141414", border: "1px solid rgba(255,0,127,0.5)", color: "#fff", fontFamily: "Outfit" }
                }}
              />
            </BackgroundMusicProvider>
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
